var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-on"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 6.27273C7.42135 6.27273 6.86639 6.5026 6.45722 6.91177C6.04805 7.32094 5.81818 7.87589 5.81818 8.45455C5.81818 9.0332 6.04805 9.58815 6.45722 9.99732C6.86639 10.4065 7.42135 10.6364 8 10.6364C8.57865 10.6364 9.13361 10.4065 9.54278 9.99732C9.95195 9.58815 10.1818 9.0332 10.1818 8.45455C10.1818 7.87589 9.95195 7.32094 9.54278 6.91177C9.13361 6.5026 8.57865 6.27273 8 6.27273ZM8 12.0909C7.03558 12.0909 6.11065 11.7078 5.4287 11.0258C4.74675 10.3439 4.36364 9.41897 4.36364 8.45455C4.36364 7.49012 4.74675 6.5652 5.4287 5.88325C6.11065 5.2013 7.03558 4.81818 8 4.81818C8.96442 4.81818 9.88935 5.2013 10.5713 5.88325C11.2532 6.5652 11.6364 7.49012 11.6364 8.45455C11.6364 9.41897 11.2532 10.3439 10.5713 11.0258C9.88935 11.7078 8.96442 12.0909 8 12.0909ZM8 3C4.36364 3 1.25818 5.26182 0 8.45455C1.25818 11.6473 4.36364 13.9091 8 13.9091C11.6364 13.9091 14.7418 11.6473 16 8.45455C14.7418 5.26182 11.6364 3 8 3Z",
    fill: "#373740"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOn);
export default __webpack_public_path__ + "static/media/eye-on.643ec7c22b80854feb47f70288dd6118.svg";
export { ForwardRef as ReactComponent };